import { useCodeSparkVariant } from "../featureFlags";

export function RenderUnleashVariant({
    control = null,
    featureId,
    variantName,
    children,
  }) {
    const variant = useCodeSparkVariant(featureId);

    // wait for variant to be ready
    if (!variant) return null;

    if (variant.name === variantName) {
      return children;
    }

    return control;
}



// WEBPACK FOOTER //
// ./src/utils/experiments.js